import { createContext, useContext } from 'react';

// Element in the page header's action row that page content can portal into.
export const HeaderSlotContext = createContext<HTMLElement | null>(null);

export function useHeaderSlot(): HTMLElement | null {
  return useContext(HeaderSlotContext);
}
